import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import TagManager from 'react-gtm-module';
import { useOAT } from 'common/providers/oatProvider';

const hotjarSiteId = process.env.GATSBY_HOTJAR_SITE_ID;

const gtmId = process.env.GATSBY_GOOGLE_TAG_MANAGER;

const Analytics = () => {
  const { clientId, restaurantId } = useOAT();

  const shouldTrack = !!(clientId && restaurantId);

  useEffect(() => {
    if (shouldTrack) {
      TagManager.initialize({
        gtmId,
        dataLayer: {
          oatClientId: clientId,
          oatRestaurantId: restaurantId,
        },
      });
    }
  }, [clientId, restaurantId, shouldTrack]);

  if (!shouldTrack) {
    return null;
  }

  return (
    <div data-testid="analytics">
      <Helmet>
        {hotjarSiteId && (
          <script>
            {`
              (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:${hotjarSiteId},hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `}
          </script>
        )}
      </Helmet>
    </div>
  );
};

export default Analytics;
